'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/call-bind-apply-helpers/reflectApply.js
// module id = 5613
// module chunks = 0